import { render, staticRenderFns } from "./expiredContractList.vue?vue&type=template&id=58ed5639&scoped=true"
import script from "./expiredContractList.vue?vue&type=script&lang=js"
export * from "./expiredContractList.vue?vue&type=script&lang=js"
import style0 from "./expiredContractList.vue?vue&type=style&index=0&id=58ed5639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed5639",
  null
  
)

export default component.exports